import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { CourseService } from 'src/app/services/http/business/course/course.service';
import { TranslateService } from '@ngstack/translate';
import { MatPaginator, MatTableDataSource, MatDialogRef, MAT_DIALOG_DATA, MatSelect, MatDialog } from '@angular/material';
import { IGetFullTimeSession } from 'src/app/interfaces/get-fullTime-session';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { CourseTypeService } from 'src/app/services/http/business/course-type/course-type.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import * as moment from "jalali-moment";
import { TeacherSelectionComponent } from 'src/app/components/teacher-selection/teacher-selection.component';
import { TermInfoService } from 'src/app/services/http/business/term-info/term-info.service';
import { ITermInfo } from 'src/app/interfaces/term-info';
import { CourseSessionsComponent } from 'src/app/components/course-sessions/course-sessions.component';

@Component({
  selector: 'app-course-selection',
  templateUrl: './course-selection.component.html',
  styleUrls: ['./course-selection.component.css']
})
export class CourseSelectionComponent implements OnInit {
  isOwner: boolean;
  showTable: boolean;
  isFree: boolean=false;
  filter: any;
  form: FormGroup;
  errors = new Array();
  errObject: any;
  param: any;
  coursePatternList = [];
  termList: ITermInfo[];
  courseTypeList = [];


  dataSource = new MatTableDataSource();

  displayedColumns: string[] = [
    "level",
    "teacherName",
    "courseTime",
    "status",
    "function"
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public translate: TranslateService,
    private fb: FormBuilder,
    private errorService: ErrorsService,
    private snackBar: SnackBarService,
    private courseTypeService: CourseTypeService,
    private courseService: CourseService,
    private termInfoService: TermInfoService,
    private dialogRef: MatDialogRef<CourseSelectionComponent>,
    private dialog: MatDialog,

    @Inject(MAT_DIALOG_DATA) public data: IGetFullTimeSession

  ) { }

  ngOnInit() {
    this.createForm()
    this.getCourseType();
    
    this.filter = this.data;
    this.getTermInfo(this.filter.ParentTerm.Id);
  }
  createForm() {
    this.form = this.fb.group({
      CourseTypeId: [null, Validators.required],
      CoursePatternId: [null, Validators.required],
      TermInfoId: [null, Validators.required],
      isFree: [true],
    });
  }
  getCourseType() {
    this.courseTypeService.list(0, 0).subscribe(res => {
      this.courseTypeList = res.DataList;
    });
  }

  loadCoursePattern(e: MatSelect) {
   
    this.coursePatternList = this.courseTypeList.find(item => item.Id == e.value).CoursePatternList;
  }
  getTermInfo(patternId) {
   
    this.termInfoService.getListComboById(patternId, 0, 0).subscribe(
      res => {
       
        this.termList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }
  loadCoursList() {
    this.refresh();
  }

  refresh() {
   
    this.filter["CoursePatternId"] = this.form.controls["CoursePatternId"].value;
    this.filter["TermInfoId"] = this.form.controls["TermInfoId"].value;
    let command: any = {
      BranchEncryptId: this.filter.Branch.Id,
      TermInfoId: this.filter.TermInfoId,
      CoursePatternId: this.filter.CoursePatternId.Id,
    };
    this.showTable = true;
    this.courseService.getCourseForeMakeUp(command).subscribe(result => {
     
      this.dataSource = null;
   // todo is not clen code 
      //let arry = [];
      // let cources = [];
      // result.forEach(item => {
      //   item.RoomTimeList.forEach(element => {
      //     element["RoomId"] = item.RoomId;
          
      //     arry.push(element);
      //   });
      // });

      //result = arry;
      this.dataSource = result;
      this.paginator.length = result.length;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    })

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  teacherSelection(item: any,sessionId : number=0): void {
   
    let command: any = {
      CourseId: item.Id,
      SessionId: sessionId,
      TeacherUserEncryptId: item.UserEncryptId,
      RoomId: this.filter.RoomId,
      StartTime: this.filter.StartTime,
      SessionDate: this.filter.SessionDate,
      FullName: item.FullName,
      IsMakeUp: true,
    };
    this.dialog.open(TeacherSelectionComponent, {
      data: command,
      disableClose: true
    })
      .afterClosed()
      .subscribe((res) => {
       
        if (res) 
      {
       // res["SessionId"]=sessionId;
        this.addMakeup(res);
      }
      });
  }
  //
  courseSession(item: any): void {
   
    let command: any = {
      Id: item.Id,
      Title: item.CourseTypeTitle,
      StartTime: this.filter.StartTime,
      SessionDate: this.filter.SessionDate,
      FullName: item.FullName,
      LevelName: item.LevelInfoName,
    };
    this.dialog.open(CourseSessionsComponent, {
      data: command,
      //width: "700px",
      disableClose: true
    })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
            this.teacherSelection(item,res.Id);
        }
      });
  }

  addMakeup(item: any): void {
   
    let command: any = {
      TeacherUserEncryptId: item.TeacherUserEncryptId,
      CourseId: item.CourseId,
      CourseAllSessionId:item.SessionId,
      RoomId: item.RoomId,
      SessionDate: item.SessionDate,
      StartTime: item.StartTime
    };
    this.courseService.SaveMakeUp(command).subscribe(
      () => {
       
        this.snackBar.OpenSnackBar(
          this.translate.get("success.makeup"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.dialogRef.close();
      },
      err => {
        this.errObject = this.errorService.getError(err);
        this.param = this.errorService.objectError(this.errObject);
        this.errors = this.errorService.returnError(err);
      }
    );
  }
}
